import React, { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "components/sidebar/Sidebar";
import Header from "components/Header";
import ActiveUserNavbar from "components/ActiveUserNavbar";
import VisitorNavbar from "components/VisitorNavbar";
// import Header from "components/header/Header";

type Props = {
  children: ReactNode;
};

const VisitorLayout: React.FC<Props> = ({ children }) => {
  const location = useLocation();
  const shouldRenderSidebar = location.pathname !== "/error";
  const shouldRenderHeader = location.pathname !== "";
  const sectionClassName =
    location.pathname === "/error"
      ? "h-[100vh]"
      : "w-[100%] md:screen-container h-[100vh] ";

  return (
    <main className="w-[100vw] h-auto flex overflow-hidden">
      <aside className="hidden md:block">
        <Sidebar />
      </aside>

      {/* <div> */}
      <VisitorNavbar />
      {/* </div> */}
      <section className={`${sectionClassName} overflow-y-auto  `}>
        {children}
      </section>
    </main>
  );
};

export default VisitorLayout;
